import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { fetchMedia } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import Helmet from 'react-helmet';
import './MediaPage.css';

class MediaPage extends Component {

  componentDidMount()
  {
    if (!this.props.media.fields) {
      this.props.fetchMedia();
    }
  }

  render() {
    const {media} = {...this.props};

    return (
      <div className="mediabank">
        <Helmet>
          <title>{this.props.intl.messages["header.media"]}</title>
        </Helmet>
        {!media && <Loader/>}
        <p>{this.props.intl.messages["imagebank.description"]}<br />
        <a href="mailto:sales@w-restaurants.fi">sales@w-restaurants.fi</a></p>
        {media && media.map((restaurant) => (
          <div className="restaurant" key={restaurant.sys.id}>
            <div className="container">
              {restaurant.fields.logo && <div className="logo"><img src={restaurant.fields.logo.fields.file.url} alt={restaurant.fields.restaurant+' '+restaurant.fields.location} /></div>}
              <div>
                {restaurant.fields.images &&
                  <div className="images">
                    {restaurant.fields.images.map((file) => (
                      <a href={file.fields.file.url} key={file.sys.id} style={{backgroundImage: 'url('+file.fields.file.url+'?w=240&h=240)'}}>&nbsp;</a>
                    ))}
                  </div>
                }
                {restaurant.fields.mediaFiles &&
                  <div className="files">
                    {restaurant.fields.mediaFiles.map((file) => (
                      <a href={file.fields.file.url} key={file.sys.id}>
                        <span>
                          {file.fields.file.url.split('.').pop()}
                        </span>
                        <strong>{file.fields.title}</strong>
                        {'.'+file.fields.file.url.split('.').pop()}
                      </a>
                    ))}
                  </div>
                }
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

MediaPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  media: state.media
});

const mapDispatchToProps = {
  fetchMedia
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(MediaPage));


// WEBPACK FOOTER //
// ./src/containers/MediaPage.js